import Cookies from 'universal-cookie';

export default class BrowserAccessTokenStorage {
	cookies: Cookies;

	cookieName: string;

	cookieOptions: { path: string; httpOnly: boolean };

	constructor(cookieName: string, cookieOptions: { path: string; httpOnly: boolean }) {
		this.cookies = new Cookies();
		this.cookieName = cookieName;
		this.cookieOptions = cookieOptions;
	}

	loadToken(): string | null {
		const token = this.cookies.get(this.cookieName, { doNotParse: true });
		return token !== undefined ? token : null;
	}

	saveToken(token: string) {
		const expires = new Date();
		expires.setDate(expires.getDate() + 7);
		this.cookies.set(this.cookieName, token, {
			...this.cookieOptions,
			expires,
		});
	}

	removeToken() {
		this.cookies.remove(this.cookieName, { ...this.cookieOptions });
	}
}
